import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  stateOfChargeCard: {
    backgroundColor: theme.palette.shades.shade04,
    borderColor: theme.palette.shades.shade03,
    borderRadius: theme.shape.borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    cursor: 'pointer',
    padding: theme.spacing(2, 4),
  },
}))

interface Props {
  children: React.ReactElement
  onClick: () => void
  sx?: BoxProps['sx']
}

/***
 * Component that wraps the charging schedule for styling and onClick handling
 */
const ChargingScheduleWrapper: React.FC<Props> = ({ children, onClick, sx }) => {
  const { classes } = useStyles()
  return (
    <Box className={classes.stateOfChargeCard} onClick={onClick} sx={sx}>
      {children}
    </Box>
  )
}

export default ChargingScheduleWrapper
